import LoginInDialog from "components/Login/LoginInDialog";
import { checkUserAuthentication } from "functions/functions";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import ProjectRoutes from "./components/ProjectRoutes/ProjectRoutes";

function App() {
  return <ProjectRoutes />;
}
export default App;
